import { Directive, forwardRef, Input } from '@angular/core';
import { COMPONENT_DEFINITION_REF } from "../../utility/component-definition-token";

@Directive({
    selector: 'work-sessions',
    providers: [{ provide: COMPONENT_DEFINITION_REF, useExisting: forwardRef(() => WorkSessionsComponent) }]
})
export class WorkSessionsComponent {

    @Input() categoryProperty: string;

    @Input() valueProperty: string;

    @Input() valueFilter: string | Function;

    @Input() query: { property: string, predicate: string, value: any }[];

    @Input() sort: SortType;

    @Input() chartType: ChartType;

    @Input() label: string;

    @Input() unit: string;

    @Input() config: any;
}

enum SortType {
    TIME_ASC = "TIME_ASC",
    VALUE_DESC = "VALUE_DESC"
}

enum ChartType {
    COLUMN = "COLUMN",
    LINE = "LINE"
}